export const topicLocale = {
  en: {
    radio_title: 'Overall',
    region_title: 'Tier 1 Topic',
    market_title: 'Topic',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Topic',
    button_market: 'Topic',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '聚合数据',
    region_title: '一级话题',
    market_title: '话题',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '话题',
    button_market: '话题',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const topicNoTitleLocale = {
  en: {
    radio_title: 'Overall',
    region_title: 'Tier 1 Topic',
    market_title: '',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: '',
    button_market: '',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '聚合数据',
    region_title: '一级话题',
    market_title: '',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '',
    button_market: '',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const topicRadioOptions = [
  {
    value: 'global',
    text: 'All',
    textCN: '全部',
  },
];

export const topicShortcutOptions: {
  [key: string]: (
    getAllTopicLevelTwoValue: (options: any) => Array<string>,
  ) => {
    textCN: string;
    text: string;
    type: string;
    filter: (options: any) => any;
  };
} = {
  e7f672beaa5fddd166df98bc046ba4bd4: (getAllTopicLevelTwoValue) => ({
    textCN: 'OTDR',
    text: 'OTDR',
    type: 'OTDR',
    filter: (options: any) => {
      const allTopic = getAllTopicLevelTwoValue(options);
      return [
        'game stability',
        'performance issue',
        'crash',
        'lag',
        'frame/fps',
        'game size',
        'optimization',
        'bug',
        'inventory bug',
        'uninstall',
        'save issues',
        'login issues',
        'launch issues',
        'character stuck',
        'decompression issues',
        'reward issues',
        'crafting issues',
        'gameplay issues',
        'visual issues',
        'audio issues',
        'multiplayer issues',
        'download error',
        'server reset',
        'server stability',
        'serve queue',
        'packet loss',
        'server issues',
        'server disconnection',
        'server lag',
        'server preload',
        'pay difficulty',
        'pay failure',
        'pay error',
        'payment claim error',
      ].filter((item) => allTopic.includes(item));
    },
  }),
};
